import React, { Component } from 'react'
import Summary from './Summary/Summary'
import PaymentContainer from './Payment/PaymentContainer'

export default class Reservation extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className='row'>
                
                <div className='col-sm-12 col-md-4'>
                    <div>
                        <Summary
                            propertyKey={this.props.propertyKey}
                            reservation={this.props.reservation}
                            roomTypes={this.props.roomTypes}
                            changeDates={this.props.changeDates}
                            //checkIn={this.props.checkIn}
                            //checkOut={this.props.checkOut}
                            //nights={this.props.nights}
                            //adults={this.props.adults}
                            //children={this.props.children}
                            //totalPrice={this.props.totalPrice}
                            //selectedRooms={this.props.reservation.selectedRooms}
                            removeRoom={this.props.removeRoom}
                            changeRoom={this.props.changeRoom}
                            addRoom={this.props.addRoom}
                            changeAdults={this.props.changeAdults}
                            changeChildren={this.props.changeChildren}
                        />
                    </div>
                </div>
                <div className='col-sm-12 col-md-8'>
                    <div>
                        <PaymentContainer
                            reservation={this.props.reservation}
                            setPageState={this.props.setPageState}
                            
                        />
                    </div>
                    
                </div>
            </div>
        );
    }
}